export default __webpack_public_path__ + "static/media/Cabletv.113c09d0.svg";